export default __webpack_public_path__ + "static/media/card-primary.17212428.png";